import fr from "./fr";

var en = {};
for (let k in fr) en[k] = k;
export default en;
